import { z } from "zod";

const iconLibraries = [
    "regular",
    "solid",
    "duotone",
    "light",
    "brand",
    "sharp",
    "thin",
] as const;
type IconLibrary = (typeof iconLibraries)[number];

const iconLibraryZodEnum = z.enum(iconLibraries);

export { iconLibraryZodEnum };
export type { IconLibrary };
